export enum ReminderColorSchemes {
  Vivid,
  Subdued,
}
